import { render, staticRenderFns } from "./CrudDialog.vue?vue&type=template&id=70adfb8d&scoped=true"
import script from "./CrudDialog.vue?vue&type=script&lang=js"
export * from "./CrudDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70adfb8d",
  null
  
)

export default component.exports